import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { GetWeightNumber } from "./GetWeightNumber";
import { SetValueAsync } from "./SetValueAsync";
import { LogDailyGoalForCICOWeightAsync } from "./LogDailyGoalForCICOWeightAsync";

export function ChangeCICOWeight({
    newValue,
    setNewValue,
    sharedFunction,
}: {
    newValue: string;
    setNewValue: React.Dispatch<React.SetStateAction<string>>;
    sharedFunction: ESharedFunction;
}) {
    const weightNumber = GetWeightNumber(newValue);

    return (
        <div>
            <FormInput
                id={`clickTarget_input_${ESharedFunction[sharedFunction]}`}
                classes={StyleClass(`ChangeWeight_Input`, {
                    fontSize: `30px`,
                })}
                label="set to"
                type="text"
                onChange={async (event) => {
                    setNewValue(event.target.value);
                }}
                onEnter={async () => {
                    if (!weightNumber) {
                        return;
                    }

                    setNewValue(`0`);
                    await SetValueAsync(weightNumber, sharedFunction);
                    await LogDailyGoalForCICOWeightAsync();
                }}
                value={newValue}
                width="80px"
                inputMode="decimal"
            />
            <Render id="setWeightLink" when={weightNumber && weightNumber > 0}>
                <span style={{ margin: `5px` }}>
                    <IconWithText
                        iconSuffix={EGlyphicon.ok}
                        whenClicked={async () => {
                            if (!weightNumber) {
                                return;
                            }

                            setNewValue(`0`);
                            await SetValueAsync(weightNumber, sharedFunction);
                            await LogDailyGoalForCICOWeightAsync();
                        }}
                        displayAsBlock={false}
                    />
                </span>
            </Render>
        </div>
    );
}
